import { api } from 'api/client';
import { Team } from 'types/team';

export const fetchTeams = () => api.get<Team[]>('/team');
